import useContractWrite from "./useContractWrite";
import { LocalStorageKeys } from "@/constants";
import { orderProcessorContract, useSmartWallet } from "@/contexts/SmartWallet";
import { customPrepareContractCall } from "@/helper/thirdweb";

const useOrdersWrite = () => {
  const {
    mutateAsync: acceptOrderMutateAsync,
    isLoading: acceptOrderIsLoading,
    error: acceptOrderError,
  } = useContractWrite();
  const { account } = useSmartWallet();

  const {
    mutateAsync: completeOrderMutateAsync,
    isLoading: completeOrderIsLoading,
    error: completeOrderError,
  } = useContractWrite();

  const acceptOrder = async (orderId: string, userEncUpi: string) => {
    if (!acceptOrderError && !acceptOrderIsLoading) {
      try {
        const pubKey = JSON.parse(
          localStorage.getItem(LocalStorageKeys.RELAY_IDENTITY) as string,
        ).publicKey;
        const acceptOrderTransaction = await customPrepareContractCall({
          contract: orderProcessorContract,
          method: "acceptOrder",
          params: [orderId, userEncUpi, pubKey ?? ""],
          address: account?.address,
        });

        const result = await acceptOrderMutateAsync([
          acceptOrderTransaction as any,
        ]);
        return result;
      } catch (error) {
        console.error("acceptOrder -- catch -- error -->", error);
        return error;
      }
    } else {
      console.log(
        "!acceptOrderError && !acceptOrderLoading",
        !acceptOrderError,
        !acceptOrderIsLoading,
      );
      console.log("acceptOrderError ", acceptOrderError);

      return acceptOrderError;
    }
  };

  const completeOrder = async (orderId: string) => {
    if (!completeOrderError && !completeOrderIsLoading) {
      try {
        const completeOrderTransaction = await customPrepareContractCall({
          contract: orderProcessorContract,
          method: "completeOrder",
          params: [orderId],
          address: account?.address,
        });

        const result = await completeOrderMutateAsync([
          completeOrderTransaction as any,
        ]);
        console.log("completeOrder -- result -->", result);
        return result;
      } catch (error) {
        console.error("completeOrder -- catch -- error -->", error);
        return error;
      }
    } else {
      console.log(
        "!completeOrderError && !completeOrderLoading",
        !completeOrderError,
        !completeOrderIsLoading,
      );

      return completeOrderError;
    }
  };

  return {
    acceptOrder,
    completeOrder,
  };
};

export default useOrdersWrite;
